import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "careerHistoryTab" }
const _hoisted_2 = { class: "wizard-action" }
const _hoisted_3 = { class: "d-flex ga-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_TextAreaFieldWithAIGenerator = _resolveComponent("TextAreaFieldWithAIGenerator")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_CareerHistoryList = _resolveComponent("CareerHistoryList")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_CareerHistoryRegister = _resolveComponent("CareerHistoryRegister")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center text-md-left"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("h1", null, "Career History", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { loading: _ctx.dataLoading }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InfoBox, { title: "Tell us a little about your Career History" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_form, {
                                ref: "frmRegisterSummary",
                                modelValue: _ctx.valid,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.valid) = $event)),
                                "lazy-validation": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_TextAreaFieldWithAIGenerator, {
                                    computedOptions: 
                      _ctx.items?.map((item) => _ctx.getDetailName(item.JobTitle) + '-' + item.JobSkills.map((skill) => _ctx.getSkillName(skill)).join('-'))
                    ,
                                    readonly: _ctx.isHiringmanager,
                                    id: "CareerHistoryDescription",
                                    placeholder: "Describe your main area of experience, your current role, your roles to date ...",
                                    showRequired: "",
                                    counter: "",
                                    rules: [_ctx.validations.required, _ctx.validations.minCharDesc],
                                    modelValue: _ctx.careerHistorySummaryDescription,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.careerHistorySummaryDescription) = $event)),
                                    outlined: ""
                                  }, null, 8, ["computedOptions", "readonly", "rules", "modelValue"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            md: "12",
                            class: "text-right pt-0"
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.isHiringmanager)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    class: "primary_btn",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveCareerHistoryDescription())),
                                    loading: _ctx.loading
                                  }, {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createTextVNode(" Save")
                                    ])),
                                    _: 1
                                  }, 8, ["loading"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { loading: _ctx.dataLoading }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode(" Add Career History ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InfoBox, { title: "Add Your Career History here! Include your previous relevant experience, and your current role (if currently employed)" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                class: "primary_btn w-100",
                                "prepend-icon": "mdi-plus",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddAndEdit = true))
                              }, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode("Add Career History")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CareerHistoryList, {
                        isHiringmanager: _ctx.isHiringmanager,
                        onRemove: _ctx.remove,
                        onEdit: _ctx.edit,
                        details: _ctx.details,
                        skills: _ctx.skills,
                        careerHistoryList: _ctx.items
                      }, null, 8, ["isHiringmanager", "onRemove", "onEdit", "details", "skills", "careerHistoryList"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isAfterSignUp)
        ? (_openBlock(), _createBlock(_component_v_card_actions, {
            key: 0,
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_tooltip, {
                  top: "",
                  attach: ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ class: "secondary_btn" }, props, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAllDataAndSubmit(true))),
                      disabled: _ctx.submitting,
                      loading: _ctx.submitting,
                      "prepend-icon": "mdi-check"
                    }), {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("Save and exit")
                      ])),
                      _: 2
                    }, 1040, ["disabled", "loading"])
                  ]),
                  default: _withCtx(() => [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "You can save your progress and return to the application process later", -1))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    class: "primary_btn actionButton",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goBack())),
                    disabled: _ctx.loading,
                    loading: _ctx.loading,
                    "prepend-icon": "mdi-chevron-left"
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Back")
                    ])),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_v_btn, {
                    class: "primary_btn actionButton",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllDataAndSubmit(false))),
                    disabled: _ctx.submitting,
                    loading: _ctx.submitting,
                    "append-icon": "mdi-chevron-right"
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Next")
                    ])),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showRemoveConfirm,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showRemoveConfirm) = $event)),
      onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.showRemoveConfirm = false), ["esc"])),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          loading: _ctx.deleteLoading,
          onConfirm: _ctx.confirmDelete,
          onCancel: _cache[7] || (_cache[7] = ($event: any) => {
        _ctx.showRemoveConfirm = false;
        _ctx.deleteLoading = false;
      }),
          message: _ctx.confirmModel
        }, null, 8, ["loading", "onConfirm", "message"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showSaveForLaterConfirm,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showSaveForLaterConfirm) = $event)),
      "max-width": "500",
      onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.showSaveForLaterConfirm = false), ["esc"])),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          loading: _ctx.loading,
          message: _ctx.confirmModel,
          onConfirm: _ctx.saveForLator,
          onCancel: _ctx.cancelSaving
        }, null, 8, ["loading", "message", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showAddAndEdit,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showAddAndEdit) = $event)),
      onKeydown: _withKeys(_ctx.cancel, ["esc"]),
      "max-width": "1000px",
      scrollable: "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CareerHistoryRegister, {
          isHiringmanager: _ctx.isHiringmanager,
          sendReqeustLoading: _ctx.sendReqeustLoading,
          editingItem: _ctx.editingItem,
          onCancel: _ctx.cancel,
          submitting: _ctx.loading,
          onSendJobRequest: _ctx.sendJobRequest,
          onScrollToElement: _ctx.scrollToElement,
          skills: _ctx.skills,
          teammemberSkills: _ctx.teammemberSkills,
          onSaved: _ctx.saveCareerHistory,
          isAfterSignUp: _ctx.isAfterSignUp,
          details: _ctx.details
        }, null, 8, ["isHiringmanager", "sendReqeustLoading", "editingItem", "onCancel", "submitting", "onSendJobRequest", "onScrollToElement", "skills", "teammemberSkills", "onSaved", "isAfterSignUp", "details"])
      ]),
      _: 1
    }, 8, ["modelValue", "onKeydown"])
  ], 64))
}